import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlanNode} from "../view-model";

/**
 * This function transforms a {@link ClientEntity} in the {@link CreatePlanNode}
 * view model.
 *
 * Note that this function does not apply business rules during transformation;
 * it is only responsible for transforming the API model to the view model.
 *
 * @param entity
 * @see {@link prepareSimplePlan}
 */
export const toCreatePlanNode = (entity: ClientEntity): CreatePlanNode => ({
  caId: entity.caId,
  source: entity,
  selected: false,
  immutable: false,
  children: entity.children?.map(toCreatePlanNode) || []
});
